{
  "actions": {
    "login": "Log in",
    "logout": "Log out",
    "retry": "Retry",
    "next": "Next",
    "play": "Play",
    "backToLobby": "Back to Lobby"
  },
  "status": {
    "loggingIn": "Logging in...",
    "loading": "Loading…",
    "somethingWentWrong": "Something went wrong"
  }
}
